$(window).on('load', () => {
  // gallery 1
  const imgPoss = [];
  let maxX, maxY;
  const galletyItems = document.querySelectorAll('.gallery__item');
  if (galletyItems.length) {
    if (window.innerWidth > 992) {
      maxX =
        document.querySelector('.gallery__wrapper').getBoundingClientRect()
          .width - 180;
      maxY =
        document.querySelector('.gallery__wrapper').getBoundingClientRect()
          .height - 234;
      galletyItems.forEach(item => {
        placeImg(
          item.href,
          item.querySelector('img').src,
          item.querySelector('span').innerHTML
        );
      });
    } else {
      $('.gallery__item').colorbox({ rel: 'group1' });
    }
  }
  function placeImg(linkHref, imgSrc, description) {
    const { random: r, floor: f } = Math;
    const x = r() * maxX;
    const y = r() * maxY;
    const deg = Math.floor(Math.random() * (20 - 0 + 1)) + 0;
    const minus = Math.round(Math.random()) ? '-' : '';
    if (!isOverlap(x, y)) {
      var link = `
      <a data-lightbox="roadtrip" width="180" height="180" style="transform:rotate(${minus}${deg}deg); left: ${x}px; top: ${y}px;" href="${linkHref}" class="gallery__item">
        <img  width="180" height="180" src="${imgSrc}">
        <span>${description}</span>
      </a>`;

      var bodyHtml = document.querySelector('.gallery__wrapper').innerHTML;
      document.querySelector('.gallery__wrapper').innerHTML = bodyHtml + link;

      imgPoss.push({ x, y }); // record all img positions
    } else {
      placeImg(linkHref, imgSrc, description);
    }
    $('a[data-lightbox="roadtrip"]').colorbox({ rel: 'group1' });
  }

  function isOverlap(x, y) {
    // return true if overlapping
    let img = { x: 220, y: 180 };
    if (window.innerWidth > 1050) {
      img = { x: 160, y: 130 };
    }
    if (window.innerWidth > 1350) {
      img = { x: 190, y: 150 };
    }
    if (window.innerWidth > 1550) {
      img = { x: 220, y: 180 };
    }
    for (const imgPos of imgPoss) {
      if (
        x > imgPos.x - img.x &&
        x < imgPos.x + img.x &&
        y > imgPos.y - img.y &&
        y < imgPos.y + img.y
      )
        return true;
    }
    return false;
  }
  // gallery 2
  $('.gallery_2__wrapper').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.gallery_2__item').colorbox({
    rel: 'group1'
    // width: '80%'
    // innerHeight: '90%'
  });
});
